module.exports = __webpack_public_path__ + "img/analysis.0957ec5d.svg";